module.exports = __webpack_public_path__ + "static/img/img.ad8d721.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/qyjy/images/img.png
// module id = qje9
// module chunks = 1